/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { Fragment } from 'react';
import { Tooltip } from './Tooltip';

export function ActionButtonArray({ id, tooltipText = '', disabled = false, children, onClick }) {
  return (
    <Fragment>
      <Tooltip id={id} />
      <button
        type='button'
        disabled={disabled}
        className='h-full outline-none disabled:opacity-50 disabled:cursor-default'
        onClick={onClick}
        data-for={id}
        data-tip={tooltipText}
      >
        {children}
      </button>
    </Fragment>
  );
}
